@if (post) {
    <mat-card [@doubleBlink]="blinkState" class="h-100 blinking-element">
        @if (post.is_pinned && showPinnedBadge) {
            <div class="pinned">
                <mat-icon svgIcon="thumbtackIcon"></mat-icon>
            </div>
        }
        <mat-card-header [style.padding-right]="post.is_pinned && showPinnedBadge? '45px' : ''"
                         class="d-flex gap-5 align-items-center">
            <div class="head">
                @if (post.author && post.author?.id > 0) {
                    <div [matMenuTriggerFor]="menu" class="moderator clickable"
                         (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false">
                        <app-online-status-badge [isStaff]="post.author?.is_staff"
                                                 [userId]="post.author.id"></app-online-status-badge>
                    </div>
                    <div [appUserAvatar]="post.author" [matMenuTriggerFor]="menu" class="miniInitial clickable"
                         [class.onlineIndicatorOffset]="!community?.disable_online_icon_next_to_profile_picture || post.author?.is_staff"
                         (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                         mat-card-avatar>{{ post.author.username | slice: 0 : 1 | titlecase }}
                    </div>
                    <mat-menu #menu="matMenu" class="userDisplayMenu">
                        @if (userInfoMenuOpen) {
                            <app-user-info [user]="post.author"></app-user-info>
                        }
                    </mat-menu>
                } @else {
                    <div class="miniInitial" mat-card-avatar matTooltip="This post was posted anonymously">A
                    </div>
                }
            </div>
            <div [class.flex-1]="showOpenInFeed" [class.titleWidthMinusAvatar]="reducedContent" class="titleSection">
                <mat-card-title>
                    <div class="flex-row flex-space-between gap-10 breakWord">
                        @if (!showOpenInFeed) {
                            <span (click)="viewComments(post)" class="clickable">
                {{ post.title }}
              </span>
                        }
                        @if (showOpenInFeed) {
                            <span (click)="findPostInFeed(post)" [class.ellipsis]="reducedContent"
                                  class="clickable">{{ post.title }}</span>
                            <button (click)="findPostInFeed(post)"
                                    class="small-icon-button"
                                    mat-icon-button
                                    matTooltip="Go to the post in the feed">
                                <mat-icon>open_in_new</mat-icon>
                            </button>
                        }
                    </div>
                </mat-card-title>
                <mat-card-subtitle>{{ post.created_at | relativeTime }}
                    @if (!reducedContent) {
                        @for (category of post?.categories; track category) {
                            ,
                            <a [queryParams]="{ category:  category?.id}" [routerLink]="['/feed']"
                               [style.color]="category.font_color_hex + ' !important'"
                               class="blackLink">{{ this.community?.member_generated_name && category.name == 'Member Generated' ? this.community?.member_generated_name : category?.name }}
                            </a>
                        }
                        @if (post.is_closed_loop) {
                            ,
                            <a [queryParams]="{ closeTheLoop:  true }" [routerLink]="['/feed']"
                               class="blackLink">{{ this.community?.close_the_loop_name || 'Close The Loop' }}
                            </a>
                        }
                    }
                </mat-card-subtitle>
            </div>
            <div class="flex-row actionSection">
                @if ((post.likes_off || post.dislikes_off || post.comments_off) && !reducedContent) {
                    <mat-icon
                            [matTooltip]="'This post is locked and the following features have been disabled: ' +
                  (post.likes_off? 'Likes, ' : '') + (post.dislikes_off? 'Dislikes, ' : '' )+ (post.comments_off? 'Comments ' : '' )">
                        lock
                    </mat-icon>
                }
                @if ((hasCommunityRole(['moderator', 'full_admin']) || isSuperuser) && !hideActions && !post.moderated) {
                    <button (click)="markModerated(post)"
                            aria-label="Mark post as moderated"
                            class="delete-icon-button"
                            mat-icon-button matTooltip="Mark post as moderated">
                        <mat-icon color="warn">check_circle</mat-icon>
                    </button>
                }
                @if ((isSuperuser || hasCommunityRole(['full_admin']) || (user && post.author?.id === user?.id)) && !hideActions) {
                    <button (click)="editPost(post)"
                            aria-label="Edit post" class="edit-icon-button"
                            mat-icon-button matTooltip="Edit post">
                        <mat-icon>edit</mat-icon>
                    </button>
                }
                @if ((isSuperuser || hasCommunityRole(['full_admin'])) && !hideActions) {
                    <button (click)="deletePost(post.id)"
                            aria-label="Delete post" class="delete-icon-button"
                            mat-icon-button matTooltip="Delete post">
                        <mat-icon>delete</mat-icon>
                    </button>
                }
                @if ((isSuperuser || hasCommunityRole(['full_admin'])) && !hideActions && !post.is_hidden) {
                    <button (click)="hidePost(post.id, post.is_hidden)"
                            aria-label="Hide post" class="delete-icon-button"
                            mat-icon-button matTooltip="Hide post">
                        <mat-icon>visibility_off</mat-icon>
                    </button>
                }
                @if ((isSuperuser || hasCommunityRole(['full_admin'])) && !hideActions && post.is_hidden) {
                    <button (click)="hidePost(post.id, post.is_hidden)"
                            aria-label="Show post" class="delete-icon-button"
                            mat-icon-button matTooltip="Show post">
                        <mat-icon>visibility</mat-icon>
                    </button>
                }
                @if ((isSuperuser || hasCommunityRole(['full_admin', 'client'])) && !hideActions && this.selectedCommunity?.emoji_enabled) {
                    <button (click)="toggleEmoji(post)"
                            [matTooltip]="'Toggle ' + (!post?.emoji_enabled ? 'on' : 'off') + ' emoji'"
                            aria-label="Toggle emoji"
                            class="delete-icon-button"
                            mat-icon-button>
                        @if (post?.emoji_enabled) {
                            <mat-icon>face</mat-icon>
                        }
                        @if (!post?.emoji_enabled) {
                            <mat-icon>face_retouching_off</mat-icon>
                        }
                    </button>
                }
                @if ((isSuperuser || hasCommunityRole(['full_admin', 'client', 'reports_only', 'observer']) || (hasCommunityRole(['member'])) && post.heatmap_surveys?.[0]?.user_vote) && !hideActions && post.heatmap_surveys?.length) {
                    <button (click)="showHeatmapResults(post.heatmap_surveys)"
                            [matTooltip]="'Show heatmap results'"
                            aria-label="Show heatmap results"
                            class="delete-icon-button"
                            mat-icon-button>
                        <mat-icon>
                            <mat-icon>scatter_plot</mat-icon>
                        </mat-icon>
                    </button>
                }
            </div>
        </mat-card-header>
        <mat-card-content [class.reducedContent]="reducedContent">
            @if (!hideMedia) {
                <app-post-content [class.events-none]="isModalActive$ | async"
                                  [content]="post"></app-post-content>
            }
            @if (pollId && !hidePoll) {
                <div [class.mt-20]="!hideMedia">
                    <app-poll-view
                            [forceShowResults]="hasCommunityRole(['client', 'reports_only', 'full_admin', 'observer'])"
                            [pollId]="pollId"
                            [small]="smallPoll"></app-poll-view>
                </div>
            }
        </mat-card-content>
        <mat-card-actions
                [class.flex-end]="(post.comment_authors?.length <= 0 || !post.comment_authors) && !reducedContent"
                [class.flex-space-between]="post.comment_authors?.length > 0 && !reducedContent"
                class="flex-wrap">
            @if (post.comment_authors?.length > 0 && !reducedContent) {
                <div class="commentsUsersList">
                    @for (commentor of post.comment_authors; track commentor; let index = $index) {
                        @if (index < 4) {
                            <div class="pics d-flex gap-2">
                                <div [appUserAvatar]="commentor" [matTooltip]="commentor?.username"
                                     class="miniInitial d-inline-flex small"
                                     mat-card-avatar>{{ commentor?.username ? commentor?.username : 'A' | slice: 0 : 1 | titlecase }}
                                </div>
                            </div>
                        }
                    }
                    <p class="font-14">
                        @if (post.comment_authors?.length > 4) {
                            +{{ post.comment_authors?.length - 4 }}&nbsp;Others
                        }
                        Commented
                    </p>
                </div>
            }
            <div [class.flex-space-around]="reducedContent" [class.w-100]="reducedContent"
                 class="d-flex gap-5 align-items-center flex-wrap">
                @if ((post.likes_off || post.dislikes_off || post.comments_off) && reducedContent) {
                    <mat-icon
                            [matTooltip]="'This post is locked and the following features have been disabled: ' +
                  (post.likes_off? 'Likes, ' : '') + (post.dislikes_off? 'Dislikes, ' : '' )+ (post.comments_off? 'Comments ' : '' )"
                            class="lockIcon">
                        lock
                    </mat-icon>
                }
                @if (!reducedContent) {
                    <button (cdkCopyToClipboardCopied)="this.snackbarService.openSuccessSnackBar('Link to post successfully copied to clipboard');"
                            [cdkCopyToClipboard]="urlOrigin + '/feed/' + post.id"
                            class="post-action-btn specialSmallBtn"
                            mat-button
                            matTooltip="Copy share link for post">
                        <mat-icon>link</mat-icon>
                    </button>
                }
                @if (post.original_post?.id && !reducedContent) {
                    <button [routerLink]="['/feed', post.original_post?.id]"
                            class="post-action-btn"
                            mat-button
                            matTooltip="View parent post">
                        View Related Post
                    </button>
                }
                <button
                        (click)="likePost(post)"
                        [class.empty-state]="!post.likes_count"
                        [class.mat-mdc-raised-button]="post.is_liked && community?.like_post_button_bg_color_hex ? community?.like_post_button_bg_color_hex: ''"
                        [disabled]="post.likes_off || !(isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'member']))"
                        [matTooltip]="post.likes_off ?'Likes have been disabled for this post': post.liking_button_tooltip_text? post.liking_button_tooltip_text: community?.liking_button_tooltip_text? community?.liking_button_tooltip_text: 'Like post'"
                        [style.background-color]="post.is_liked ?community?.like_post_button_bg_color_hex: ''"
                        [style.color]="post.is_liked ?this.themeService.getReadableColor(community?.like_post_button_bg_color_hex): ''"
                        mat-button>
                    <mat-icon [@likeAnimation]="post.is_liked ? 'active' : 'inactive'">thumb_up</mat-icon>
                    {{ post.likes_count }}
                </button>
                <button
                        (click)="dislikePost(post)"
                        [class.empty-state]="!post.dislikes_count"
                        [class.mat-mdc-raised-button]="post.is_disliked && community?.dislike_post_button_bg_color_hex ? community?.dislike_post_button_bg_color_hex: ''"
                        [disabled]="post.dislikes_off || !(isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'member']))"
                        [matTooltip]="post.dislikes_off?' Dislikes have been disabled for this post': post.disliking_button_tooltip_text? post.disliking_button_tooltip_text: community?.disliking_button_tooltip_text? community?.disliking_button_tooltip_text: 'Dislike post'"
                        [style.background-color]="post.is_disliked ?community?.dislike_post_button_bg_color_hex: ''"
                        [style.color]="post.is_disliked? this.themeService.getReadableColor(community?.dislike_post_button_bg_color_hex): ''"
                        mat-button>
                    <mat-icon [@likeAnimation]="post.is_disliked ? 'active' : 'inactive'">thumb_down</mat-icon>
                    {{ post.dislikes_count }}
                </button>
                <button (click)="viewComments(post)" [class.empty-state]="!post.comments_count"
                        [class.mat-mdc-raised-button]="community?.view_comment_button_bg_color_hex"
                        [disabled]="post.comments_off"
                        [matTooltip]="post.comments_off ?' Comments have been disabled for this post': post.commenting_button_tooltip_text? post.commenting_button_tooltip_text: community?.commenting_button_tooltip_text? community?.commenting_button_tooltip_text: 'View comments'"
                        [style.background-color]="!post.comments_off? community?.view_comment_button_bg_color_hex: ''"
                        [style.color]="!post.comments_off? this.themeService.getReadableColor(community?.view_comment_button_bg_color_hex) : ''"
                        class="post-action-btn"
                        mat-button>
                    @if (!post.comments_off) {
                        <mat-icon>comment</mat-icon>
                    }
                    @if (post.comments_off) {
                        <mat-icon>speaker_notes_off</mat-icon>
                    }
                    Comments ({{ post.comments_count }})
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
}

